import styled from 'styled-components';

const RefreshBlockWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export default RefreshBlockWrapper;



// WEBPACK FOOTER //
// ./components/RefreshBlock/RefreshBlockWrapper.js